<script>
	const Vue = require('vue');
	const _ = require('underscore');
	const Player = require('@vimeo/player').default;
	const userContext = require('core/userContext');
	const utilities = require('utilities');
	const round = require('utilities/numberUtilities').round;

	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const VIDEO_PLAY = analyticsUtilities.events.VIDEO_PLAY;
	const VIDEO_PAUSE = analyticsUtilities.events.VIDEO_PAUSE;
	const VIDEO_COMPLETE = analyticsUtilities.events.VIDEO_COMPLETE;

	const type = 'vimeo';

	module.exports = {
		props: {
			url: {
				type: String,
				default: 'https://player.vimeo.com/video/'
			},
			videoId: {
				required: true
			},
			frameborder: {
				type: Number,
				default: 0
			},
			auth: {
				default: false
			},
			eventData: {
				default: undefined
			}
		},
		data() {
			return {
				player: null,
				lastPlayTime: null
			};
		},
		computed: {
			videoUrl() {
				let url = this.url;
				let videoId = this.videoId;

				return url + videoId;
			}
		},
		methods: {
			pause() {
				let player = this.player;
				player.play().then(() => {
					player.pause();
				});
			},
			onPlay(data) {
				this.authCheck();
				this.onEventFired(VIDEO_PLAY, data);
			},
			onPause(data) {
				this.authCheck();

				// Vimeo fires Pause & Complete at end of video
				if (data.duration !== data.seconds) {
					this.onEventFired(VIDEO_PAUSE, data);
				}
			},
			onComplete(data) {
				this.authCheck();
				this.onEventFired(VIDEO_COMPLETE, data);
			},
			onEventFired(eventName, data) {
				let id = this.videoId;
				let length = data.duration;
				let position = data.seconds;
				let eventData = { id, type, position, length };

				if (this.eventData) {
					eventData = _.assign({}, eventData, this.eventData);
				}

				if (eventName === VIDEO_PLAY) {
					this.lastPlayTime = data.seconds;
				} else if (this.lastPlayTime !== null) {
					eventData.duration = round(position - this.lastPlayTime);
					this.lastPlayTime = null;
				}

				fireEvent(eventName, eventData);
			},
			authCheck() {
				if (this.auth && !userContext.loggedIn()) {
					this.pause();
					utilities.openModal('#teacher-login-modal');
				}
			},
			initPlayer() {
				let el = this.$el;
				if (!this.player && el) {
					let player = new Player(el);
					player.on('play', this.onPlay);
					player.on('pause', this.onPause);
					player.on('ended', this.onComplete);
					this.player = player;
				}
			}
		},
		mounted() {
			Vue.nextTick(this.initPlayer);
		}
	};
</script>
<template>
	<iframe
		class="vimeo-player"
		:src="videoUrl"
		:width="width"
		:height="height"
		:frameborder="frameborder"
		webkitallowfullscreen
		mozallowfullscreen
		allowfullscreen
		allow="autoplay; fullscreen; picture-in-picture">
	</iframe>
</template>
<style scoped>
	.vimeo-player {
		margin-bottom: 1rem;
		width: 640px;
		height: 360px;
	}
</style>
